import { styled } from '@mui/material';
import { AdmissionStatus, ApplicationStatus } from '@common-types';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

import { ADMISSION_STATUS_TAGS_DATA, APPLICATION_STATUS_TAGS_COLORS } from '@constants/applyingSchoolsPlanner';

const chipSxStyles = {
  padding: '0.25rem 0.75rem',
  borderRadius: '0.5rem',
  fontSize: '0.75rem',
  lineHeight: '1.125rem',
  span: {
    padding: '0rem',
  },
};

export const sxStyles = {
  chip: {
    admissionStatus: (status: AdmissionStatus) => ({
      ...chipSxStyles,
      color: ADMISSION_STATUS_TAGS_DATA[status].color,
      backgroundColor: `${ADMISSION_STATUS_TAGS_DATA[status].color}13`,
    }),
    applicationStatus: (status: ApplicationStatus) => ({
      ...chipSxStyles,
      backgroundColor: `${APPLICATION_STATUS_TAGS_COLORS[status]}13`,
      color: APPLICATION_STATUS_TAGS_COLORS[status],
    }),
  },
};

export const StyledCard = styled(CoreBox, {
  shouldForwardProp: (prop) => prop !== 'isExtended',
})<{ isExtended: boolean }>(({ theme, isExtended }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  padding: '1.5rem 1rem',
  border: `1px solid ${coreThemeColors.grey[300]}`,
  borderRadius: '0.5rem',
  backgroundColor: coreThemeColors.common.white,
}));

export const StyledCardDivider = styled(CoreBox)(() => ({
  flex: 'none',
  alignSelf: 'stretch',
  border: `1px solid ${coreThemeColors.grey[300]}`,
}));

export const StyledCardBody = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  gap: '1rem',

  [theme.breakpoints.down('md')]: {
    paddingBottom: '0rem',
    flexDirection: 'column-reverse',
  },
}));

export const StyledCardBodyLeft = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  flex: '1 0 0',
}));

export const StyledCardBodyRight = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  width: '17rem',
  flexDirection: 'row',
  gap: '1rem',

  div: {
    width: '17rem',
  },

  [theme.breakpoints.down('md')]: {
    width: '100%',
    div: {
      width: '100%',
    },
  },
}));

export const StyledCardInfoLine = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'top',
  gap: '0.5rem',
  div: {
    flex: '0',
  },
}));
